<template>
  <div class="reflections clickable" @click="$emit('click')">
    <h5>Reflections</h5>
    <rounded-bar-chart :height="200" style="height: 200px; width: 100%;" :chart-data="info" :options="options" />
  </div>
</template>

<script>
import roundedBarChart from "@/components/charts/roundedBarChart/chart";
export default {
  components: { roundedBarChart },
  props: ["reflections"],
  data() {
    return {
      info: {},
      options: {
            legend: {
            display: false
        },
        tooltips: {
            callbacks: {
               label: function(tooltipItem) {
                      return tooltipItem.yLabel;
               }
            }
        },
        scales: {
          xAxes: [{
            barThickness: 10,
            display: false,
          }],
          yAxes: [
            {
              fontColor: "white",
              display: false,
              ticks: {
                fontColor: "white",
                beginAtZero: true,
                min: 0,
                max: 7,
                stepSize: 1
              }
            }
          ]
        }
      }
    }
  },
  created() {
    this.info = {
      labels: this.reflections,
      fill: false,
      colors: ["white"],
      datasets: [{
        data: this.reflections,
        backgroundColor: "white",
        borderColor: "white",
      }]
    }  
  }
}
</script>

<style lang="less" >
.reflections {
  width: 100%;
  height: 220px;
  margin-top: 20px;
  filter: brightness(0.80);
  &:hover {
    h5 {
      font-size: 18px;
    }
    filter: brightness(1);
  }

  canvas {
    height: 160px !important;
    border-left-style: solid;
    border-left-width: 1px;
    border-bottom-width: 1px;
    border-bottom-style: solid;
  }
  h5 {
    font-size: 15px;
    font-weight: 100;
    height: 20px;
    text-align: center;
    text-transform: uppercase;
  }
}

</style>
